import React, { Component } from 'react';
import { LuMail, LuPhone } from 'react-icons/lu';
import ContactForm from './ContactForm';
import '../stylesheet/style.css';
import '../stylesheet/Contact.css';

export default class Contact extends Component {
    render() {
        return (
            <div className='base'>
                <h1 className="sr-only">Contact</h1>
                <span className="page-watermark" aria-hidden="true">Contact</span>
                <div className="background">
                    <div className="containers">
                        <div className="screen">
                            <div className="screen-body">
                                <div className="screen-body-item left">
                                    <span className="contact-eyebrow">Get in touch</span>
                                    <div className="app-title">
                                        <span>Contact</span>
                                        <span>Me</span>
                                    </div>
                                    <p className="contact-lede">Have a project in mind or just want to say hi? Send a message and I'll get back to you soon.</p>
                                    <div className="app-contact">
                                        <a href={"mailto:sajfan21@gmail.com"}><LuMail /> sajfan21@gmail.com</a>
                                        <a href={"tel:9746646576"}><LuPhone /> +91 9746646576</a>
                                    </div>
                                </div>
                                <div className="screen-body-item">
                                    <div className="app-form">
                                        <ContactForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}